import { firstnameVar, lastnameVar } from "../config/regex/regexPattern";

export async function candidateDataPostProcess(apidata: any, params?: any) {
    let candidateFirstName = apidata?.data?.candidateDetails?.firstName || "";
    let candidateLastName = apidata?.data?.candidateDetails?.lastName || "";
    let mutatedData = apidata;

    const transformValues = (fieldData: string) => {
        let transformedString = fieldData;
        if (transformedString.match(firstnameVar)) {
            transformedString = transformedString.replace(
                firstnameVar,
                " " + candidateFirstName,
            );
        }
        if (transformedString.match(lastnameVar)) {
            transformedString = transformedString.replace(
                lastnameVar,
                " " + candidateLastName,
            );
        }
        return transformedString;
    };

    mutatedData.data?.data.forEach((dataItem: any) => {
        dataItem.fields?.forEach((field: any) => {
            // Auto fill full name
            if (field.fullName) {
                field.value = `${candidateFirstName} ${candidateLastName}`.trim();
            }

            if (field.pdfLabel) {
                field.pdfLabel = transformValues(field.pdfLabel);
            }
            if (field.label) {
                field.label = transformValues(field.label);
            }

            if (field.values) {
                field.values.forEach((fieldValue: any) => {
                    if (fieldValue.label) {
                        fieldValue.label = transformValues(fieldValue.label);
                    }
                });
            }
        });
    });

    return mutatedData;
}
